import { LEARN_THEME_SPECS, getLearnSeoPage, learnCompleteNavigationGroups } from "../content/learnPages";

// Temas de Aprender (rediseño del 2026-10-18). Desde la reescritura de las guías (2026-10-18) los
// temas y sus apartados se definen en content/learnPages.js (LEARN_THEME_SPECS).

export const learnSlugFromPath = (path) =>
  String(path || "")
    .replace(/^\/game\/learn\/?/, "")
    .replace(/^\/aprender\/?/, "")
    .replace(/[?#].*$/, "")
    .replace(/^\/+|\/+$/g, "")
    .toLowerCase();

const toGuide = (item) => {
  const slug = learnSlugFromPath(item.path);
  const page = getLearnSeoPage(slug);
  return {
    ...item,
    slug: page?.slug || slug,
    description: page?.metaDescription || page?.intro || "",
  };
};

const buildThemes = () =>
  LEARN_THEME_SPECS.map((spec) => {
    const seenSlugs = new Set();
    const sections = learnCompleteNavigationGroups
      .filter((group) => group.themeId === spec.id)
      .map((group) => ({
        label: group.label,
        guides: group.items.map(toGuide).filter((guide) => {
          if (seenSlugs.has(guide.slug)) return false;
          seenSlugs.add(guide.slug);
          return true;
        }),
      }))
      .filter((section) => section.guides.length > 0);
    return {
      id: spec.id,
      icon: spec.icon,
      label: spec.label,
      groups: sections.map((section) => section.label),
      sections,
      guides: sections.flatMap((section) => section.guides),
    };
  });

export const LEARN_THEMES = buildThemes();

export const LEARN_ALL_GUIDE_SLUGS = Array.from(
  new Set(LEARN_THEMES.flatMap((theme) => theme.guides.map((guide) => guide.slug)))
);

export const findLearnThemeOfSlug = (slug) => {
  const value = String(slug || "").toLowerCase();
  return LEARN_THEMES.find((theme) => theme.guides.some((guide) => guide.slug === value)) || null;
};
